import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, GUARANTEE_LINE } from '../utils/constants';
interface CTAButtonProps {
  label?: string;
  subtext?: string | null;
  tone?: 'blue' | 'gold';
  onDark?: boolean;
}
export function CTAButton({
  label = 'GET INSTANT ACCESS NOW',
  subtext = GUARANTEE_LINE,
  tone = 'blue',
  onDark = false
}: CTAButtonProps) {
  const toneClasses = tone === 'gold' ? 'bg-gold-500 text-navy-950 hover:bg-gold-600 focus-visible:outline-gold-500' : 'bg-brand-500 text-white hover:bg-brand-600 focus-visible:outline-brand-400';
  return <div className="w-full" data-id="element-8" data-mp="33pfjflalxhcw">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center font-display text-[15px] font-extrabold uppercase leading-tight tracking-wide shadow-cta transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 sm:text-lg md:py-5 ${toneClasses}`} data-id="element-9" data-mp="33ommfc1ga67y">
        <span data-id="element-10" data-mp="1d9yipmvv9o4z">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-11" data-mp="1db9n9ox4yzx5" />
      </a>
      {subtext && <p className={`mt-3 text-center text-[11px] font-medium leading-relaxed sm:text-xs ${onDark ? 'text-brand-100/80' : 'text-navy-800/70'}`} data-id="element-12" data-mp="1n9gzxvke6vtc">
          {subtext}
        </p>}
    </div>;
}